var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { forwardRef } from 'react';
import { css } from '@emotion/react';
import { Search, Close } from '@sumup/icons';
import styled from '../../styles/styled';
import Input from '../Input';
import IconButton from '../IconButton';
import { AccessibilityError } from '../../util/errors';
const clearButtonStyles = ({ theme }) => css `
  border: none;
  margin: 0 !important;
  width: auto !important;
  pointer-events: all !important;
  cursor: pointer !important;
  padding: 16px !important;
  border-radius: ${theme.borderRadius.byte};
`;
const ClearButton = styled(IconButton)(clearButtonStyles);
/**
 * SearchInput component for forms.
 */
export const SearchInput = forwardRef((_a, ref) => {
    var { value, onClear, clearLabel } = _a, props = __rest(_a, ["value", "onClear", "clearLabel"]);
    if (process.env.NODE_ENV !== 'production' &&
        process.env.NODE_ENV !== 'test' &&
        onClear &&
        !clearLabel) {
        throw new AccessibilityError('SearchInput', 'The `clearLabel` prop is missing. Omit the `onClear` prop if you intend to disable the input clearing functionality.');
    }
    return (_jsx(Input, Object.assign({ value: value, type: "text", renderPrefix: (renderProps) => _jsx(Search, Object.assign({ size: "16" }, renderProps)), renderSuffix: (renderProps) => value && onClear && clearLabel ? (_jsx(ClearButton, Object.assign({ onClick: onClear, label: clearLabel }, renderProps, { children: _jsx(Close, { size: "16" }) }))) : null }, props, { ref: ref })));
});
SearchInput.displayName = 'SearchInput';
